import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Shows an "Unlock" control on any locked item for users without an active subscription.
// Not logged in  -> opens Sign In (then continues to plans/payment after login)
// Logged in, free -> opens the payment dialog directly
export const UnlockButton = ({ locked, variant = "overlay", className = "", label = "Unlock", testid = "unlock-btn", planId }) => {
  const { isAuthed, isSubscribed } = useAuth();
  if (!locked || isSubscribed) return null;

  const click = (e) => {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    if (!isAuthed) { window.dispatchEvent(new Event("open-auth")); return; }
    window.dispatchEvent(new CustomEvent("open-subscribe", { detail: { planId } }));
  };

  const pos = variant === "overlay" ? "absolute bottom-2.5 left-2.5 z-20" : "inline-flex";
  return (
    <span role="button" tabIndex={0} onClick={click}
      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") click(e); }}
      data-testid={testid}
      className={`${pos} cursor-pointer items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#E11D2A] hover:bg-[#C8121F] text-white text-xs font-extrabold uppercase tracking-wide btn-glow transition-colors ${className}`}>
      <Lock className="w-3.5 h-3.5" /> {label}
    </span>
  );
};
